import {
  DELETE_PROJECT_ACTIVITY_REQUEST,
  DELETE_PROJECT_ACTIVITY_ERROR,
  DELETE_PROJECT_ACTIVITY_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/deleteEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default entity => (state = initialState, action) => {

  context.init(context);

  context.DELETE_ENTITY_REQUEST = DELETE_PROJECT_ACTIVITY_REQUEST;
  context.DELETE_ENTITY_ERROR = DELETE_PROJECT_ACTIVITY_ERROR;
  context.DELETE_ENTITY_SUCCESS = DELETE_PROJECT_ACTIVITY_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "projectActivity";
  context.entityLocation = RESOURCES.ProjectActivities;

  return context.execute(context)(entity)(state, action);
};

